// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 여권 판매 부스 키오스크 - 기본 리셋 스타일
 */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ══════════════ 동영상 — 네이티브 재생 오버레이 전역 억제 (2026-08-18) ══════════════
   증상: 영상이 뜰 때 "플레이 버튼 모양 화면"이 잠깐 보였다 사라진 뒤 재생됐다.

   원인: Android WebView·크롬은 \`controls\` 속성이 없어도 autoplay 가 실제로 시작되기
   전 구간에 네이티브 재생 오버레이를 그린다.

   🔴 **클래스가 아니라 \`video\` 요소로 건다.** 예전에는 화면마다 같은 규칙을 복사해 뒀는데
      (\`.qt-first-mission-video\` 에만 있었다) 새 영상 3종(\`oxq-verdict\`·\`oxq-greet\` 등)에
      빠져서 같은 증상이 재발했다. 여기 한 곳에 두면 앞으로 추가되는 영상도 자동으로 덮인다.

   ⚠️ 전제: 이 앱의 영상은 네이티브 컨트롤을 쓰지 않는다(전부 autoplay 연출용).
      \`controls\` 가 필요한 영상이 생기면 그 영상만 예외를 둬야 한다 —
      회귀 가드: \`src/videoPlayOverlay.test.js\` 가 \`controls\` 사용을 막아 세운다.

   ⚠️ 이것만으로는 부족하다. 기기에 따라 플레이 아이콘이 아니라 빈 판이 먼저 뜨기도 해서,
      각 영상은 재생 시작 전까지 \`opacity: 0\` 게이트를 함께 건다(같은 테스트가 전수 확인). */
video::-webkit-media-controls-start-playback-button,
video::-webkit-media-controls-overlay-play-button,
video::-webkit-media-controls-play-button {
  display: none !important;
  opacity: 0;
  pointer-events: none;
  -webkit-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;+DAe+D;AAC/D;;;EAGE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B","sourcesContent":["/**\n * 여권 판매 부스 키오스크 - 기본 리셋 스타일\n */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* ══════════════ 동영상 — 네이티브 재생 오버레이 전역 억제 (2026-08-18) ══════════════\n   증상: 영상이 뜰 때 \"플레이 버튼 모양 화면\"이 잠깐 보였다 사라진 뒤 재생됐다.\n\n   원인: Android WebView·크롬은 `controls` 속성이 없어도 autoplay 가 실제로 시작되기\n   전 구간에 네이티브 재생 오버레이를 그린다.\n\n   🔴 **클래스가 아니라 `video` 요소로 건다.** 예전에는 화면마다 같은 규칙을 복사해 뒀는데\n      (`.qt-first-mission-video` 에만 있었다) 새 영상 3종(`oxq-verdict`·`oxq-greet` 등)에\n      빠져서 같은 증상이 재발했다. 여기 한 곳에 두면 앞으로 추가되는 영상도 자동으로 덮인다.\n\n   ⚠️ 전제: 이 앱의 영상은 네이티브 컨트롤을 쓰지 않는다(전부 autoplay 연출용).\n      `controls` 가 필요한 영상이 생기면 그 영상만 예외를 둬야 한다 —\n      회귀 가드: `src/videoPlayOverlay.test.js` 가 `controls` 사용을 막아 세운다.\n\n   ⚠️ 이것만으로는 부족하다. 기기에 따라 플레이 아이콘이 아니라 빈 판이 먼저 뜨기도 해서,\n      각 영상은 재생 시작 전까지 `opacity: 0` 게이트를 함께 건다(같은 테스트가 전수 확인). */\nvideo::-webkit-media-controls-start-playback-button,\nvideo::-webkit-media-controls-overlay-play-button,\nvideo::-webkit-media-controls-play-button {\n  display: none !important;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
